// extracted by mini-css-extract-plugin
export default {"delete_button":"ImageFieldDropzonePreview_delete_button__-35Ci"};